// @generated da scripts/i18n-sr-cyrl.mjs — NON EDITARE A MANO.
// i18n area 'vms' — locale sr-Cyrl-RS: TRASLITTERAZIONE MECCANICA
// di vms.sr-Latn-RS.ts (srpska latinica). Ogni modifica va fatta
// sulla locale sr-Latn-RS e poi rigenerata con: node scripts/i18n-sr-cyrl.mjs
// Sidecar anti-stantie: ../meta/vms.sr-Cyrl-RS.meta.json.
import type { enUS } from './vms'

export const srCyrlRS: typeof enUS = {
  vms: {
    spof: {
      title: 'Независност од чвора',
      single: 'Јединствена тачка отказа',
      alternativesNow: 'Алтернативе сада',
      structural: 'По конструкцији',
      binding: 'Обавезујуће ограничење',
      movableNow: 'Миграција могућа сада',
    },
    title: 'Виртуелне машине',
    migratingChip: 'Миграција у току',
    templateChip: 'Шаблон',
    expendableTooltip: 'У деградираном кластеру међу првима пада и можда се неће поново покренути после губитка чвора.',
    expendableHaTooltip: 'Увек се рестартује док је кластер здрав; у деградираном кластеру заштићене VM имају предност — може бити заустављена или остати угашена док кластер поново не буде цео, а онда се сама враћа.',
    viewDetails: 'Прикажи детаље',
    profileLegacy: 'Други OS',
    hugePagesNone: 'Ниједна — обична меморија',
    hugePages2M: 'Странице од 2 MiB',
    hugePages1G: 'Странице од 1 GiB',
    searchPlaceholder: 'Претражи по имену',
    name: 'Име',

    // Terminologia UNA (#94a): la phase si chiama 'Fase' ovunque — la
    // vecchia chiave 'state' è morta col polish della lista.
    vcpus: 'vCPU',
    memory: 'Меморија',
    ipAddresses: 'IP адресе',
    noIp: 'Нема IP адресе',
    authorityNode: 'Authority',
    authorityNextStart: 'додељује се при следећем покретању',
    scope: 'Scope',
    empty: 'Нема виртуелних машина',
    loadError: 'Није могуће учитати виртуелне машине — да ли је TVirt backend доступан?',
    filterOverlay: 'overlay мрежа',
    filterDisk: 'диск',
    filterImage: 'слика',
    filteredBy: 'Филтрирано по: {kind}',
    filterPhase: 'Фаза',
    filterProtection: 'Заштита',
    filterAll: 'Све',
    filterScopePlaceholder: 'Филтрирајте по scopeu',
    filtersToggle: 'Филтери',
    scopeTree: {
      title: 'Scope',
      all: 'Цео кластер',
      noChildren: 'Овде нема под-scopeova',
      recursive: 'Укључи потомке',
      collapse: 'Скупи панел scopeova',
      up: 'Један ниво навише',
      countTooltip: 'VM-ова у овом scopeu: {direct} · са потомцима: {total}'
    },

    // Il picker ISO a due passi (#85): prima il catalogo, poi le sue ISO.
    isoPicker: {
      catalog: 'Каталог',
      unknownCatalog: 'Ван видљивих каталога',
      noIsos: 'Нема спремних ISO слика у овом каталогу'
    },
    actionsHeader: 'Акције',
    templatesTab: {
      quickDeploy: 'QuickDeploy',
      hardware: 'Хардвер',
      tags: 'Тагови',
      age: 'Старост',
      disk: 'диск',
      disks: 'дискова',
      empty: 'Још нема шаблона — означите угашену VM као шаблон, или клонирајте VM као шаблон.',
      clone: 'Клонирај / deploy',
      editTags: 'Измени тагове',

      // Round K3 (#64): esporta il template come file .tvtpl del catalogo.
      exportAction: 'Извези у каталог (.tvtpl)',
      exportTitle: 'Извезите у каталог',
      exportSubmit: 'Извези',
      exportError: 'Извоз није успео',
      exportHint: 'Шаблон се пакује у .tvtpl архиву (хардверски manifest + сваки диск изравнат у qcow2) као нова Template VM датотека у изабраном каталогу. NIC-ови, CD/DVD медији и cloud-init не путују — spec формата наводи свако намерно изостављање.',
      exportName: 'Име датотеке',
      exportNameHint: 'Празно = <template>-export-<n>',
      exportStorageDefault: 'Storage метаподатака шаблона',

      // Importa da catalogo (Luca 2026-08-03): l'ingresso in toolbar del tab
      // Template — il backend K3/K4 copre tutti i formati vm-template, la
      // scelta è il FILE (il formato viaggia in sola lettura).
      importAction: 'Увези из каталога',
      importTitle: 'Увезите из каталога',
      importHint: 'Template VM датотека у стању ready из изабраног каталога постаје шаблон инвентара: формат датотеке (tvtpl, ова, ovf или голи qcow2) сам одлучује како се увози — ви бирате само датотеку.',
      importFile: 'Датотека каталога',
      importFileHint: 'Увозе се само датотеке у стању ready — датотека усред отпремања није увозива',
      importNoFiles: 'У овом каталогу нема Template VM датотека у стању ready — прво отпремите или извезите једну'
    },
    templateDetail: {
      quickDeploy: 'Компатибилност са QuickDeploy',
      quickDeployNone: 'Није декларисана',
      quickDeployHint: 'Декларишите је само ако голден слика садржи cloud-init (Linux) или cloudbase-init након sysprep /генерализе (Windows): платформа верује декларацији и никада не гледа унутар госта.',
      notFound: 'Шаблон није пронађен',
      frozen: 'Хардверска конфигурација је замрзнута: конвертујте шаблон назад у VM да бисте је изменили. Име, белешке и тагови остају измењиви.',
      storage: 'Storage',
      size: 'Величина',
      configTitle: 'Конфигурација (замрзнута)',
      usbClasses: 'Захтеване USB класе',
      gpuClasses: 'Захтеване GPU класе'
    },
    sharedDisksTab: {
      title: 'Дељени дискови',
      sharing: 'Дељење',
      sharingNone: 'Једно прикључење',
      sharingMultiwriter: 'Дељено писање (multiwriter)',
      sharingReadonly: 'Дељено само за читање',
      usedBy: 'Користи',
      attachedTo: 'Прикључен на',
      notAttached: 'Није прикључен ни на једну VM',
      changeSharing: 'Промени режим дељења',
      changeSharingTitle: 'Режим дељења',
      changeSharingLocked: 'Режим се мења само док ниједна VM не користи диск',
      sharingChanged: 'Режим дељења ажуриран.',
      lun: 'Цео LUN',
      lunNumber: 'LUN / namespace',
      lunWwn: 'WWN',
      lunSerial: 'Серијски број',
      antiAffinityWarning: 'Два или више чланова раде на истом чвору без правила анти-афинитета: отказ једног чвора обара их све',
      antiAffinityCreate: 'Направи правило',
      createSourceLun: 'Преузми цео LUN targeta',
      createLunNumber: 'Број LUN-а (ид namespace-a на NVMe)',
      createLunHint: 'Ништа се не додељује: величина се очитава са уређаја при преузимању',
      noPr: 'У овом издању нема SCSI-3 персистент ресерватионс: Windows Failover Cluster са класичним дељеним диском није валидиран; кластери који се координирају мрежом (GFS2/OCFS2, RHEL HA, shared-disk базе) јесу'
    },
    unusedDisksTab: {
      title: 'Некоришћени дискови',
      attach: 'Прикачи на VM',
      attachTitle: 'Прикачите на VM',
      vm: 'Виртуелна машина',
      noVms: 'Нема доступних VM-ова',
      noSlots: 'Нема слободних slotova на овој VM',

      // Crea disco standalone (#87): tornato dall'Inventario pensionato, ora
      // con campo scope ESPLICITO (non c'è una VM da cui ereditare).
      create: 'Креирај диск',
      createTitle: 'Креирајте диск',
      createSourceBlank: 'Празан диск',
      createSourceImage: 'Из слике у каталогу',
      createImage: 'Слика',
      createImageEmpty: 'Нема спремне слике VM шаблона у видљивим каталозима',
      createSizeFromImageHint: 'Унапред попуњено виртуелном величином слике — може само да расте',

      // #107 (DISTRUTTIVO, ratificato): qcow2 → catalog file vm-template
      // sullo stesso storage, zero byte copiati — il disco cessa di esistere.
      convert: 'Конвертуј у VM шаблон…',
      convertOnlyQcow2: 'Конвертују се само qcow2 дискови — raw није формат шаблона који се може регистровати',
      convertTitle: 'Конвертујте у VM шаблон',
      convertSubmit: 'Конвертуј (уништава диск)',
      convertError: 'Није могуће покренути конверзију',
      convertWarning: 'ДЕСТРУКТИВНО: диск постаје датотека VM шаблона у изабраном каталогу — исти storage, нула копираних бајтова — и ПРЕСТАЈЕ ДА ПОСТОЈИ као диск. Повратка нема, осим креирањем новог диска из шаблона.',
      convertNameHint: 'Име датотеке каталога — подразумевано име самог диска',
      convertConfirm: 'Разумем: диск ће бити уништен',
      convertStarted: 'Конверзија је покренута — шаблон се појављује у каталогу по завршетку задатка.',
      storageLockHint: 'Storage се мења само акцијом Премести',
      source: 'Порекло',
      sourceClone: 'Клон другог диска',
      sourceCloneLinked: 'Linked clone другог диска',
      sourceImage: 'Креиран из слике',
      sourceBlank: 'Креиран празан',
      allocated: 'Алоцирано / виртуелна величина',
      observedAt: 'Посматрано',
      snapshots: 'Снимци',
      snapshotsEmpty: 'Нема снимака'
    },
    phase: {
      defined: 'Никад упаљена',
      starting: 'Покреће се',
      running: 'У току',
      stopping: 'Зауставља се',
      stopped: 'Угашена',
      paused: 'Паузирана',
      failed: 'У грешци',
      deleting: 'Брише се'
    },
    stopCause: {
      'api': 'Зауставио ју је TVirt (акција или API)',
      'guest-shutdown': 'Shutdown покренут из guest оперативног система',
      'crash': 'Crash guesta',
      'qemu-exit': 'QEMU процес се неочекивано завршио',
      'host-reboot': 'Чвор је рестартован',
      'migrated': 'Мигрирана на други чвор',
      'fenced': 'Прекинута HA fencingom (чвор се вратио)'
    },
    detail: {
      notFound: 'Виртуелна машина није пронађена',
      details: 'Детаљи',
      id: 'ID',
      scope: 'Scope',
      profile: 'Хардверски профил',
      firmware: 'Firmware',
      firmwareFile: 'UEFI firmware верзија',
      firmwareUpdate: 'Доступно ажурирање',
      firmwareUpdateHint: 'Платформа испоручује новији UEFI firmware. Ажурирање никад није аутоматско: примењује се док је VM угашена, кад ви одлучите.',
      arch: 'Архитектура',
      node: 'Чвор',
      bootOrder: 'Редослед покретања',
      agent: 'Статус агента',
      agentConnected: 'Повезан',
      agentNotConnected: 'Није повезан',
      protected: 'Заштићена',
      linkedClones: 'Повезани клонови',
      restartPolicy: 'Политика рестартовања',
      preferredNode: 'Жељени чвор',
      noPreference: 'Без преференције (аутоматски placement)',
      preferNodes: 'Жељени тагови чворова',
      requireNodes: 'Обавезни тагови чворова',
      noPlacementTags: 'Ниједна',
      placementTag: 'Таг',
      placementValue: 'Вредност',
      placementAddTag: 'Додај таг',
      proximityHa: 'TVirt Proximity HA',
      proximityHaRestarts: 'HA рестартовања',
      proximityHaGaveUp: 'crash loop — HA је одустао',
      failoverProtection: 'Заштита при деградацији',
      protectionProtected: 'Заштићена',
      protectionExpendable: 'Потрошна при деградацији',
      protectionInherit: 'Наслеђује',
      lastStop: 'Последње заустављање',
      yes: 'Да',
      no: 'Не',
      tabOverview: 'Преглед',
      tabSnapshots: 'Снимци',
      tabBackups: 'Копије',
      hardware: 'Хардвер',
      name: 'Име',
      hwSystem: 'Систем',
      hwCpu: 'CPU',
      hwMemory: 'Меморија',
      hwBoot: 'Покретање',
      hwIdentity: 'Идентитет',
      hwCluster: 'Кластер и агент',
      cpuTopology: 'CPU топологија',
      cpuModel: 'CPU модел',
      cpuLimit: 'CPU лимит',
      cpuWeight: 'CPU тежина',
      cpuNested: "Угнежђена виртуелизација",
      cpuNestedHint: "Излаже vmx/свм госту (само са CPU моделом хост). На упаљеној VM измена важи од следећег power cycle-a (PendingRestart); распоређивање дозвољава само чворове са укљученим нестед.",
      unlimited: 'Неограничено',
      memory: 'Меморија',
      balloon: 'Balloon',
      hugePages: 'Огромне странице',
      hugePagesTradeoff: 'Мање посла око превођења адреса и меморија која никад не одлази на диск; заузврат резервација остаје закључана на чвору док је VM упаљена, меморија се више не дедупликује, а покретање не успева ако чвор нема довољно слободних страница.',
      disks: 'Дискови',
      cdroms: 'CD/DVD уређаји',
      nics: 'Мрежни интерфејси',
      slot: 'Slot',
      disk: 'Диск',
      encrypted: 'Шифрован',
      image: 'Слика',
      emptyDrive: 'Празан уређај',
      emptyOption: '(празно)',
      network: 'Мрежа',
      mac: 'MAC',
      connected: 'Повезан',
      unplugged: 'Откачен',
      noDevices: 'Ниједан',
      screenshot: 'Снимак екрана',
      capturedAt: 'Снимљено у',
      noCapture: 'Још нема снимка екрана',
      snapshotName: 'Име',
      snapshotCreated: 'Креиран',
      snapshotMemory: 'Меморија укључена',
      noSnapshots: 'Нема снимака',
      pendingRestart: 'Измене на чекању: примениће се при следећем power cycleu.',
      applied: 'примењено',
      appliedHint: 'VM тренутно ради са овом вредношћу — конфигурисана вредност се примењује при следећем power cycleu.',
      actionError: 'Акција није успела',
      actionStillRunning: 'Акција је још у току: исход још није познат',
      tabConsole: 'Конзола',
      consoleConnect: 'Повежи',
      consoleDisconnect: 'Прекини везу',
      consoleConnecting: 'Повезивање…',
      consoleReconnecting: 'Повезивање…',
      consoleUnavailable: 'Конзола је доступна док VM ради или је паузирана.',
      consoleError: 'Повезивање на конзолу није успело',
      consoleTaken: 'Конзолну сесију је преузео {user}',
      consoleReconnect: 'Повежи поново',
      consoleCtrlAltDel: 'Ctrl+Alt+Del',
      consoleHold: 'Држите притиснуто {key}',
      consoleFn: 'Fn…',
      consoleFullscreen: 'Отвори преко целог екрана у новом табу',
      consoleLoadFailed: 'VM није пронађена или су дозволе недовољне',
      consoleClose: 'Затвори',
      tabStats: 'Статистика',
      tabTasks: 'Задаци',
      tabLogs: 'Logovi',
      statsCpu: 'CPU',
      statsMemory: 'Меморија',
      statsDisk: 'I/O диска',
      statsRange: 'Интервал',
      statsNoData: 'Нема података у интервалу — статистика се узоркује док VM ради.',
      statsError: 'Није могуће учитати статистику',
      cpuUsage: 'Искоришћеност',
      cpuReady: 'Ready (%RDY)',
      memUsed: 'Искоришћена',
      memGuestAvailable: 'Доступна (guest)',
      schema: 'Шема',
      consoleProtocol: 'Конзола',
      agentEnabled: 'Guest агент',
      metadataStorage: 'Storage метаподатака',
      startupOnBoot: 'Покретање при bootu',
      startupOrder: 'Редослед старта',
      startupDelay: 'Одлагање старта',
      seconds: 'с',
      enabled: 'Омогућено',
      disabled: 'Онемогућено'
    },
    actionsAvailable: 'Доступне акције',
    actions: {
      start: 'Покрени',
      stop: 'Заустави',
      pause: 'Паузирај',
      resume: 'Настави',
      reset: 'Ресетуј',
      migrate: 'Мигрирај',
      clone: 'Клонирај',
      moveStorage: 'Премести на storage…',
      moveScope: 'Премести у scope…',
      openConsole: 'Отвори конзолу',
      forceStop: 'Принудно угаси',
      markTemplate: 'Означи као шаблон',
      unmarkTemplate: 'Конвертуј назад у VM',
      error: 'Није могуће извршити акцију'
    },
    cordon: {
      confirmTitle: 'Чвор је у одржавању',
      confirmHint:
        'Кордон се не може спустити док је store кластера недоступан. Потврдом изјављујете да то знате: VM се тамо ипак покреће, а сагласност остаје забележена на задатку.',
      confirm: 'Ипак покрени'
    },
    markTemplate: {
      confirmTitle: 'Означити {name} као шаблон?',
      confirmBody: 'Конфигурација се замрзава и VM више не може да се упали — може само да се клонира, или врати у VM. Име, белешке и тагови остају измењиви.',
      confirm: 'Означи као шаблон',
      moved: '{name} је сада шаблон — премештена је у таб Шаблони.'
    },
    unmarkTemplate: {
      confirmTitle: 'Конвертовати {name} назад у VM?',
      confirmBody: 'Шаблон поново постаје обична VM: измењива и може да се покрене (следеће покретање је смешта на чвор).',
      confirm: 'Конвертуј назад у VM',
      moved: '{name} је поново виртуелна машина — премештена је у таб Виртуелне машине.'
    },

    // Round #123: riferimento a nodo per TAG (selettore #106) nei dialog
    // di start e migrazione — anteprima dell'insieme risolto inclusa.
    nodeByTag: {
      label: 'По ознаци чвора',
      hint: 'таг=вредност, одвојено зарезима (у AND комбинацији): decider бира међу одговарајућим чворовима',
      invalid: 'Неисправан формат — користите таг=вредност, одвојено зарезима',
      resolved: 'Одговарајући чланови: {nodes}'
    },
    migrate: {
      title: 'Live миграција',
      submit: 'Мигрирај',
      target: 'Одредишни чвор',
      auto: 'Аутоматски (Proximity)',
      hint: 'VM се премешта без power cyclea. Сваки storage који додирује мора бити дељен; паузирана VM мигрира паузирана.',
      error: 'Миграција је одбијена'
    },
    moveStorage: {
      title: 'Преместите на storage',
      submit: 'Премести',
      target: 'Одредишни storage',
      noTargets: 'Ниједан storage не прима дискове',
      hint: 'Сви дискови угашене VM путују на изабрани storage, један по један, задржавајући свој ид — они који су већ на одредишту се прескачу. Напредак живи на страници задатака.',
      error: 'Премештање је одбијено'
    },
    moveScope: {
      title: 'Преместите у scope',
      submit: 'Премести',
      target: 'Одредишни scope',
      hint: 'VM одмах мења scope — ид и дискови остају, њени owned дискови је прате, и може остати упаљена. Тренутно живи у {scope}. Ко је види мења се са scopeom.',
      error: 'Премештање у scope је одбијено'
    },
    start: {
      title: 'Покрените VM',
      submit: 'Покрени',
      target: 'Одредишни чвор',
      auto: 'Аутоматски (препоручено)',
      recommended: 'препоручено',
      hint: 'Изаберите одредишни чвор или препустите да Proximity смести VM бирајући међу важећим кандидатима. Чворови који не могу да је угосте онемогућени су уз разлог.',
      error: 'Није могуће покренути VM'
    },
    console: {
      media: 'CD/DVD уређаји',
      mediaGuestToolsHint: 'Садржи TVirt Guest Tools — одавде можете да их избаците или уклоните уређај',
      slotOpsDeferred: 'На овом профилу додавање и уклањање уређаја примењују се при следећем power cycleu (промене медија су тренутне).',
      mountGuestTools: 'Монтирај TVirt Guest Tools',
      ejectGuestTools: 'Избаци TVirt Guest Tools',
      bootOrder: 'Редослед покретања',
      bootOrderHint: 'Нови редослед се чува одмах и примењује при следећем power cycleu — конзолна сесија остаје повезана.'
    },
    snapshots: {
      create: 'Креирај снимак',
      createTitle: 'Креирајте снимак',
      createSubmit: 'Креирај',
      name: 'Име',
      nameHint: 'Слова, цифре, тачка, цртица, доња црта.',
      consistencyHint: 'Конзистентност је аутоматска: guest агент замрзава filesysteme када одговори; у супротном се VM накратко паузира око снимка.',
      memory: 'Укључи меморију',
      memoryHint: 'Хвата живу RAM: враћање наставља VM у раду. Захтева да сви дискови буду qcow2.',
      currentChip: 'Овде сте',
      revert: 'Врати',
      revertTitle: 'Вратити на {name}?',
      revertBody: 'Дискови се враћају на стање снимка; све што се десило после њега је изгубљено. Снимак само дискова захтева заустављену VM.',
      delete: 'Обриши',
      deleteTitle: 'Обрисати снимак {name}?',
      deleteBody: 'Тачка враћања нестаје; садржај дискова остаје нетакнут.',
      deleteMergeHint: 'Његова делта се спаја у {children}: свака каснија тачка враћања остаје важећа.',
      deleteDuplication: 'Прихватам дуплирање',
      deleteDuplicationHint: 'Делта се копира у сваког од {count} читалаца (снапсхоти деца и, ако је овај тренутни, активна глава): заузети простор може да расте уместо да се смањује.',
      error: 'Операција над снимком је одбијена'
    },
    clone: {
      title: 'Клонирајте VM',
      submit: 'Клонирај',
      name: 'Име копије',
      storage: 'Одредишни storage за дискове',
      sameStorage: 'Исти као извор',
      full: 'Пуна копија',
      fullHint: 'Копира сваки бајт и кида везу са изворним дисковима. Подразумевани је linked clone: тренутан, али везан ланцем за извор (само qcow2).',
      hint: 'Клон задржава конфигурацију и firmware извора; MAC адресе и TPM идентитет су нови.',
      markAs: 'Тип клона',
      markAsInheritVm: 'Као извор (VM)',
      markAsInheritTemplate: 'Као извор (шаблон)',
      markAsVm: 'Виртуелна машина',
      markAsTemplate: 'Шаблон',
      markAsHintVm: 'Изаберите Шаблон да бисте копију унапредили у једном кораку.',
      markAsHintTemplate: 'Изаберите Виртуелна машина за deploy из овог шаблона у једном кораку.',
      error: 'Клонирање је одбијено'
    },
    bulk: {
      selected: 'изабрано',
      deleteTitle: {
        one: 'Обрисати изабрани VM ({count})?',
        few: 'Обрисати изабране VM-ове ({count})?',
        other: 'Обрисати изабране VM-ове ({count})?'
      },
      deleteBody: 'Свака VM пролази исте провере као појединачно брисање; одбијања се пријављују по ставци.',
      done: 'прихваћено',
      refused: 'одбијено'
    },
    delete: {
      button: 'Обриши',
      confirmTitle: 'Обрисати {name}?',
      confirmBody: 'Виртуелна машина и дискови у њеном власништву биће обрисани. Операција је неповратна.',
      keepDisks: 'Задржи дискове',
      keepDisksHint: 'Дискови креирани са VM остају на свом storageu као самостални дискови.',
      confirm: 'Обриши',
      cancel: 'Откажи',
      error: 'Брисање није успело',
      blockedPhase: 'Прво зауставите VM',
      blockedProtected: 'VM је заштићена — прво уклоните заштиту',
      blockedDeleting: 'Брисање је већ у току'
    },
    logs: {
      title: 'Logovi',
      subtitle: 'Структурирани log фрејмови из задатака који дирају ову VM',
      when: 'Када',
      task: 'Задатак',
      level: 'Ниво',
      message: 'Порука',
      empty: 'Још нема logova',
      loadError: 'Није могуће учитати logove — да ли је TVirt backend доступан?'
    },
    stop: {
      title: 'Зауставите виртуелну машину',
      modeGraceful: 'Graceful гашење',
      modeGracefulHint: 'Од guest оперативног система се тражи да се природно угаси (ACPI); ако игнорише захтев, после timeouta следи принудно гашење.',
      modeForced: 'Принудно гашење',
      modeForcedHint: 'Одмах сече напајање, као извлачење утикача.',
      timeout: 'Fallback timeout (у секундама)',
      timeoutHint: 'Колико дуго чекати guest пре принудног гашења'
    },

    // Il menu del bottone split di creazione (Luca 2026-07-23): "Da zero" apre
    // il wizard, le altre due voci sono stub di roadmap.
    createFromScratch: 'Од нуле',
    createFromTemplate: 'Из шаблона',
    createQuickDeploy: 'TVirt QuickDeploy',

    quickDeploy: {
      title: 'TVirt QuickDeploy',
      submit: 'Изврши deploy',
      error: 'Deploy није успео',
      compatNote: 'QuickDeploy захтева шаблон компатибилан са QuickDeploy: платформа прилагођава госта (мрежа, домен, активација) при првом покретању.',
      template: 'Шаблон',
      noTemplates: 'Ниједан шаблон још не декларише компатибилност са QuickDeploy — декларишите је на картици Шаблони (Linux са cloud-init, Windows са cloudbase-init након sysprep)',
      osLinux: 'Linux (cloud-init)',
      osWindows: 'Windows (cloudbase-init)',
      hostname: 'Име хоста',
      hostnameHint: 'Име хоста или FQDN; празно = име VM (Windows: највише 15 знакова)',
      ip: 'IP адреса',
      ipHint: 'Хост и префикс, нпр. 192.168.122.101/24; празно = DHCP',
      gateway: 'Gateway',
      dns: 'DNS сервери',
      dnsHint: 'До три, одвојени зарезом',
      count: 'Instance',
      countHint: 'Више од једне: назване <ime>-1…-N, само DHCP',
      user: 'Корисник',
      userHint: 'Празно = подразумевани корисник слике (Linux) или Администратор (Windows)',
      password: 'Лозинка',
      passwordHint: 'Уписује се у генерисани user-data, који платформа затим декларише тајним: нико га више не чита',
      sshKeys: 'Јавни SSH кључеви',
      sshKeysHint: 'Један по реду (ссх-ed25519 AAAA… коментар)',
      productKey: 'Product key за Windows',
      kmsServer: 'KMS сервер',
      kmsHint: 'Хост или хост:порт — захтева product key (KMS клијентски кључ)',
      adDomain: 'Придружи домену Active Directory',
      adDomainHint: 'Празно = без придруживања домену',
      adUser: 'Налог за придруживање',
      adPassword: 'Лозинка налога за придруживање',
      adOu: 'Одредишна OU (опционо)',
      advanced: 'Напредно: сирови документи',
      userData: 'user-data (сирови)',
      userDataHint: 'Замењује генерисани user-data: корисник, лозинка, кључеви и Windows поља изнад морају остати празни',
      networkConfig: 'network-config (сирови)',
      networkConfigHint: 'Замењује генерисану мрежу: IP, gateway и DNS изнад морају остати празни',
      secret: 'Третирај сирови user-data као тајну',
      secretHint: 'Означен тајним, API га више никоме не враћа и у Checkpoint-u путује запечаћен masterpass-om',
      startNow: 'Покрени одмах',
      startNowHint: 'Свака инстанца се покреће чим је дефинисана; seed настаје при том покретању'
    },

    create: {
      nicAttachmentNetwork: 'Логичка мрежа (fabric)',
      nicNetwork: 'Логичка мрежа',
      nicNetworkHint: 'PREPORUČENI пут (F3): vNIC се остварује на IZVEDENOM bridge-u послужујућег чвора — bridge се рађа при експлицитном fabric apply-u, а покретање на чвору који га још не носи одбија говорећи. Кад оде задња референца флоте, bridge испада при следећем apply-u.',
      button: 'Креирај VM',
      title: 'Креирајте виртуелну машину',
      dialogTitle: 'Креирајте виртуелну машину',
      stepGeneral: 'Опште',
      stepGeneralHint: 'Име и профил',
      stepCompute: 'CPU и RAM',
      stepComputeHint: 'Топологија и димензионисање',
      stepDisks: 'Дискови',
      stepDisksHint: 'Креирајте или прикачите',
      stepCdroms: 'CD/DVD',
      stepCdromsHint: 'Уређаји и медији',
      stepNetwork: 'Мрежа',
      stepNetworkHint: 'NIC-ови: trunk или bridge',
      stepSummary: 'Резиме',
      stepSummaryHint: 'Проверите и креирајте',
      name: 'Име',
      nameHint: 'Мала слова, цифре и цртице (DNS-1123)',
      nextButton: 'Даље',
      prevButton: 'Назад',
      submitButton: 'Креирај',
      creating: 'Креирање…',
      sockets: 'Socketi',
      cores: 'Core по socketu',
      threads: 'Thread по coreu',
      totalVcpus: 'Укупно vCPU',
      memoryGib: 'Меморија (GiB)',
      cpuModelHint: "'хост' излаже CPU хоста",
      cpuLimitHint: 'Лимит у хост coreovima — празно = неограничено',
      cpuNestedHint: "Излаже vmx/свм госту да би могао да покреће сопствени хипервизор — захтева CPU модел хост и чвор са укљученим нестед",
      newDisk: 'Нови диск',
      attachDisk: 'Прикачи постојећи диск',
      diskStorage: 'Storage',
      diskSize: 'Величина (GiB)',
      diskSelect: 'Диск',
      addDisk: 'Додај диск',
      addCdrom: 'Додај CD/DVD уређај',
      addNic: 'Додај мрежни интерфејс',
      remove: 'Уклони',
      slotLimit: 'Достигнут лимит slotova',
      cdromImage: 'Слика (празан уређај ако је нема)',
      nicAttachment: 'Прикључак',
      nicAttachmentTrunk: 'Overlay trunk',
      nicAttachmentBridge: 'Хост bridge',
      nicUntagged: 'Untagged overlay',
      nicUntaggedNone: 'Ниједна (само tagged)',
      nicTrunkHint: 'Бар једна страна: untagged overlay и/или tagged VLAN мапирања — VM може да ради само на хостовима које декларише свака референцирана overlay мрежа',
      nicTaggedVlan: 'VLAN ID',
      nicTaggedOverlay: 'Overlay мрежа',
      addTagged: 'Додај tagged VLAN',
      nicBridge: 'Име хост bridgea',
      nicBridgeHint: 'NM хост bridge по имену — VM може да ради само на серверима чија хост мрежа декларише овај bridge',
      nicMac: 'MAC (аутоматски ако је празно)',
      noDisksHint: 'Нема дискова: VM ће имати само CD/DVD уређаје које додате.',
      noCdromsHint: 'Нема CD/DVD уређаја: додајте један за покретање са ISO слике.',
      mountGuestTools: 'Монтирај TVirt Guest Tools при првом покретању',
      mountGuestToolsHint: 'Ставља ISO са virtio драјверима и guest агентом у празан CD уређај (додат по потреби) — Windows инсталеру су потребни да би видео своје дискове.',
      noNicsHint: 'Нема мрежних интерфејса: VM ће се покренути без повезивости.',
      taggedMappings: 'Tagged VLAN мапирања',
      summaryDevices: 'Уређаји',
      bootOrderTitle: 'Редослед покретања',
      bootOrderHint: 'Превуците да промените редослед — побеђује први уређај са ког се може покренути; NIC-ови покрећу PXE',
      bootOrderUp: 'Помери навише',
      bootOrderDown: 'Помери наниже',
      createError: 'Креирање није успело'
    },
    edit: {
      button: 'Измени',
      title: 'Измените виртуелну машину',
      cancel: 'Откажи',
      save: 'Сачувај',
      error: 'Измена није успела',
      modelStoppedOnly: 'Измењиво само док је VM угашена',
      firmwareStoppedOnly: 'Firmware је измењив само док је VM угашена — при следећем покретању машина креће са новим firmwareom, а UEFI варијабле остају',
      hugePagesStoppedOnly: 'Измењиво само док је VM угашена — при следећем покретању меморија настаје на новом backingu',
      runningHint: 'Измене се примењују при следећем power cycleu',
      sectionCpu: 'CPU',
      sectionMemory: 'Меморија',
      sectionPolicy: 'Политике'
    },
    devices: {
      networkChip: 'fabric мрежа',
      title: 'Уређаји',
      usb: 'USB',
      gpu: 'GPU',
      addUsb: 'Додај USB уређај',
      addUsbTitle: 'Захтевајте класу USB уређаја',
      usbClassHint:
        'VM тражи КЛАСУ USB уређаја (вредност тага usb-device), никад појединачан уређај: при покретању се бира и резервише конкретан слободан уређај на изабраном чвору. Тагујте регистроване уређаје у Кластер › USB и PCIe ресурси.',
      usbTag: 'Таг (usb-device)',
      usbValue: 'Вредност класе',
      noUsbTags: 'Још нема usb-device тагова — креирајте један и тагујте регистроване уређаје у Кластер › USB и PCIe ресурси.',
      noUsbValues: 'Овај таг још нема декларисане вредности.',
      usbEmpty: 'Нема USB захтева — додајте класу да би уређај био пропуштен при покретању.',
      usbClassChip: 'класа',
      usbPortChip: 'порт',
      usbUnclaimed: 'Ниједан уређај није резервисан — решава се при покретању VM.',
      addGpu: 'Додај GPU',
      addGpuTitle: 'Захтевајте класу GPU',
      gpuClassHint:
        'VM тражи КЛАСУ GPU (вредност тага gpu-device), никад конкретну картицу: при покретању се конкретна слободна картица бира и резервише на изабраном чвору, и њена ЦЕЛА IOMMU група пролази заједно. Тагујте регистроване GPU у Кластер › USB и PCIe ресурси.',
      gpuTag: 'Таг (gpu-device)',
      gpuValue: 'Вредност класе',
      noGpuTags: 'Још нема gpu-device тагова — креирајте један и тагујте регистроване GPU у Кластер › USB и PCIe ресурси.',
      noGpuValues: 'Овај таг још нема декларисане вредности.',
      gpuEmpty: 'Нема GPU захтева — додајте класу да би картица била пропуштена при покретању.',
      gpuClassChip: 'класа',
      gpuGroupChip: 'IOMMU група ×',
      gpuUnclaimed: 'Ниједна картица није резервисана — решава се при покретању VM.',
      gpuPowerCycle: 'Нема GPU хотплуга — измене важе од следећег power cyclea (PendingRestart)',
      actions: 'Акције',
      attachDisk: 'Додај диск',
      attachDiskTitle: 'Додајте диск',
      attach: 'Прикачи',
      noFreeDisks: 'Нема некоришћених дискова — креирајте један у Виртуелне машине › Некоришћени дискови.',
      addCdrom: 'Додај уређај',
      addCdromTitle: 'Додајте CD/DVD уређај',
      editCdromTitle: 'Промените CD/DVD слику',
      changeMedia: 'Промени CD/DVD слику',
      ejectMedium: 'Избаци',
      mountGuestTools: 'Монтирај TVirt Guest Tools',
      guestToolsMounted: 'TVirt Guest Tools монтиране',
      guestToolsClickMount: 'Ставља TVirt Guest Tools ISO у први празан CD/DVD уређај',
      guestToolsClickUnmount: 'Кликните за избацивање — уређај остаје, празан',
      guestToolsNoSlot: 'Нема празног CD/DVD уређаја — додајте уређај (или избаците медиј) да бисте монтирали TVirt Guest Tools',
      guestToolsSkew: 'Монтирано v{pinned}; чвор {node} сада служи v{current}: избаци и поново монтирај да ажурираш',
      ejectGuestTools: 'Избаци TVirt Guest Tools (уређај остаје, празан)',
      guestToolsEjectConfirmTitle: 'Избацити TVirt Guest Tools?',
      guestToolsEjectConfirmBody: 'Медиј се избацује из упаљене VM — CD/DVD уређај остаје, празан.',
      applyLive: 'Примени одмах (VM је упаљена)',
      addNic: 'Додај интерфејс',
      addNicTitle: 'Додајте мрежни интерфејс',
      editNicTitle: 'Измените мрежни интерфејс',
      bridgeChip: 'bridge',
      cable: 'Виртуелни кабл',
      plug: 'Прикачи виртуелни кабл',
      unplug: 'Откачи виртуелни кабл',
      remove: 'Уклони',
      removeTitle: 'Уклонити {device}?',
      removeBody: 'На упаљеној VM измена се примењује при следећем power cycleu. Дискови и слике се откачињу, никад не бришу.'
    }
  }
}
